.chips-view {
  margin-bottom: 8px;
  display: flex;
  flex-wrap: wrap;
}

qds-chip {
  margin: 0 8px 8px 0;
  display: inline-block;
}
